import {LabTest} from "./lab-test.model";

/**
 * Model reprezentujący zdeserializowany obiekt danych laboratoryjnych (Wrapper).
 * Służy jako główny kontener (Root Object) po przeparsowaniu ciągów znaków
 * z formatu JSON na silnie typowane struktury
 * gotowe do użycia w interfejsie użytkownika.
 */
export class LabTestDataObj {

  /** Tablica głównych badań laboratoryjnych wykonanych w ramach jednej wizyty.
   * Przechowuje pełne drzewo wyników.
   */
  public labTests: LabTest[];

}
